/* @flow */
import Columns2 from 'components/Columns2.jsx';
import Image from 'components/Image.jsx';
import React from 'react';
import Text from 'components/Text.jsx';
import TextAppLinkForm from 'user/components/TextAppLinkForm.jsx';

import './styles/TextAppLink.scss';

export default class extends React.Component {
  render() {
    return (
      <div className="TextAppLink">
        <Columns2 reset="tablet" flex>
          <div>
            <h1 className="TextAppLink-title">Get the Remind app</h1>
            <Text color="thunder" element="p" size="small">
              Send and receive messages instantly on your phone.
            </Text>
            <TextAppLinkForm />
          </div>
          <Image
            src={require('assets/images/TextAppLink/apps.png')}
            srcSet={`${require('assets/images/TextAppLink/apps@2x.png')} 2x`}
            alt="Remind mobile apps"
          />
        </Columns2>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/user/components/TextAppLink.jsx